/* eslint-disable jsx-a11y/anchor-is-valid */
import {
	Avatar,
	Box,
	IconButton,
	makeStyles,
	Popover,
} from "@material-ui/core";
import {
	ArrowDropDownCircleSharp,
	Edit,
	ExitToApp,
	Lock,
	Person,
} from "@material-ui/icons/";
import PopupState, { bindPopover, bindTrigger } from "material-ui-popup-state";
import { useContext, useState } from "react";
import Swal from "sweetalert2";
import authContext from "../../context/Auth/authContext";
import EditPassword from "../molecules/EditPassword";
import EditProfile from "../molecules/EditProfile";
import Profile from "../molecules/Profile";
import "./index.css";

const useStyles = makeStyles((theme) => ({
	iconButton: {
		position: "relative",
		display: "flex",
		alignItems: "center",
		justifyContent: "center",
		borderRadius: "50%",
	},
	Box: {
		overflowY: "visible",
		height: "auto",
		minWidth: "200px",
	},
}));

const DropdownMenu = (props) => {
	const [open, setOpen] = useState(false);
	const [avatar, setAvatar] = useState(false);
	const [openEdit, setOpenEdit] = useState(false);
	const [openEditPassword, setOpenEditPassword] = useState(false);
	const AuthContext = useContext(authContext);
	const { user } = AuthContext;

	const classes = useStyles();
	const auth = useContext(authContext);
	const { logout } = auth;

	const handleClickOpenEditPassword = () => {
		setOpenEditPassword(!openEditPassword);
		setOpen(false);
	};

	const handleClickOpenEdit = () => {
		setOpenEdit(!openEdit);
		setOpen(false);
	};

	const handleClickOpen = () => {
		setAvatar(true);
		setOpen(!open);
	};
	const handlePopover = () => {
		setOpen(!open);
	};

	const handleClose = () => {
		setAvatar(false);
		setOpen(false);
	};

	const DropdownItem = (props) => {
		return (
			<a href="#" className="menu-item">
				<span className="icon-button">{props.leftIcon}</span>
				{props.children}
				<span className="icon-right">{props.rightIcon}</span>
			</a>
		);
	};

	const handleLogOut = () => {
		logout();
		window.location.reload();
	};

	const swalSuccess = (e) => {
		e.preventDefault();
		handleClose();
		Swal.fire({
			type: "success",
			title: "Anda yakin ingin keluar?",
			icon: "warning",
			showCancelButton: true,
			cancelButtonText: "Tidak",
		}).then((result) => {
			if (result.value) {
				handleLogOut();
			}
		});
	};

	return (
		<>
			<PopupState variant="popover" popupId="demo-popup-popover">
				{(popupState) => (
					<>
						<div {...bindTrigger(popupState)}>
							<IconButton
								variant="contained"
								color="inherit"
								className={classes.iconButton}
								onClick={() => handlePopover()}
							>
								<Avatar
									style={{ marginRight: "6px", textTransform: "capitalize" }}
								>
									{user?.nama_user}
								</Avatar>
								<ArrowDropDownCircleSharp fontSize="medium" />
							</IconButton>
						</div>
						<Popover
							{...bindPopover(popupState)}
							anchorOrigin={{
								vertical: "bottom",
								horizontal: "right",
							}}
							transformOrigin={{
								vertical: "top",
								horizontal: "right",
							}}
							open={open}
							onClose={handlePopover}
						>
							<Box className={classes.Box}>
								<div className="menu">
									<div
										onClick={handleClickOpen}
										style={{ textTransform: "capitalize" }}
									>
										<DropdownItem leftIcon={<Person />}>PROFILE</DropdownItem>
									</div>
									<div
										onClick={handleClickOpenEdit}
										style={{ textTransform: "capitalize" }}
									>
										<DropdownItem leftIcon={<Edit />}>
											EDIT PROFILE
										</DropdownItem>
									</div>
									<div
										onClick={handleClickOpenEditPassword}
										style={{ textTransform: "capitalize" }}
									>
										<DropdownItem leftIcon={<Lock />}>
											EDIT PASSWORD
										</DropdownItem>
									</div>
									<div
										onClick={swalSuccess}
										style={{ textTransform: "capitalize" }}
									>
										<DropdownItem leftIcon={<ExitToApp />}>
											SIGN OUT
										</DropdownItem>
									</div>
								</div>
							</Box>
						</Popover>
					</>
				)}
			</PopupState>
			<Profile open={avatar} handleClose={handleClose} />
			<EditProfile open={openEdit} handleCloseModal={handleClickOpenEdit} />
			<EditPassword
				open={openEditPassword}
				handleCloseModal={handleClickOpenEditPassword}
			/>
		</>
	);
};

export default DropdownMenu;
